












































import {Component, Vue} from "vue-property-decorator";
import MainPaneTemplate from "@/components/templates/loggedin/MainPaneTemplate.vue";
import PasswordlessService from "@/components/domains/auth/passwordlessService";
import {AuthPolicy, emailFieldError, toAuthError} from "@/components/domains/auth/authPolicy";
import {AuthGetterTypes} from "@/store/auth/types";

const RESEND_COOLDOWN_S = 60;

/** Signed-in: add an email address to an account that has none. */
@Component({
  components: {MainPaneTemplate}
})
export default class MailAddressSetup extends Vue {
  name = "MailAddressSetup";

  policy: AuthPolicy | null = null;
  phase: 'form' | 'sent' = 'form';
  email = '';
  sentTo = '';
  error = '';
  info = '';
  sending = false;
  cooldown = 0;
  timer: number | null = null;

  get user(): { userId?: string; email?: string | null } | null {
    return this.$store.getters[AuthGetterTypes.getCurrentUser];
  }

  get userLoaded(): boolean {
    return !!(this.user && this.user.userId);
  }

  get currentEmail(): string {
    return this.user && this.user.email ? String(this.user.email) : '';
  }

  mounted(): void {
    PasswordlessService.loadPolicy({fresh: true}).then((p) => (this.policy = p));
  }

  beforeDestroy(): void {
    this.stopTimer();
  }

  stopTimer(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  startCooldown(): void {
    this.cooldown = RESEND_COOLDOWN_S;
    this.stopTimer();
    this.timer = window.setInterval(() => {
      this.cooldown -= 1;
      if (this.cooldown <= 0) this.stopTimer();
    }, 1000);
  }

  async send(address: string): Promise<boolean> {
    this.error = '';
    this.sending = true;
    try {
      await PasswordlessService.requestMailAddressSetup(address);
    } catch (e) {
      const err = toAuthError(e, 'メールを送れませんでした。しばらくしてから、もう一度お試しください。');
      if (err.status === 401 && !err.reason) {
        this.$router.push('/login');
        return false;
      }
      this.error = err.message;
      return false;
    } finally {
      this.sending = false;
    }
    this.startCooldown();
    return true;
  }

  async submit(): Promise<void> {
    this.info = '';
    const v = this.email.trim();
    const invalid = emailFieldError(v, true);
    if (invalid) {
      this.error = invalid;
      return;
    }
    if (await this.send(v)) {
      this.sentTo = v;
      this.phase = 'sent';
    }
  }

  async resend(): Promise<void> {
    this.info = '';
    if (this.cooldown > 0 || this.sending) return;
    if (await this.send(this.sentTo)) this.info = 'もう一度送りました。';
  }

  changeAddress(): void {
    this.phase = 'form';
    this.error = '';
    this.info = '';
  }
}
